import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";
import { logoutUser } from "../../store/actions";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';

const Logout = () => {
  const dispatch = useDispatch();

  // Selector to check if the user has been logged out
  const logoutpage = createSelector(
    (state) => state.login,
    (loginState) => ({
      isUserLogout: loginState.isUserLogout,
    })
  );

  // Extracting the logout status from the Redux store
  const { isUserLogout } = useSelector(logoutpage);

  useEffect(() => {
    // Dispatch the logout action to clear session data
    dispatch(logoutUser());
  }, [dispatch]);

  // If the user is successfully logged out, redirect to the login page
  if (isUserLogout) {
    return <Navigate to="/login" />;
  }

  return <></>;
};

Logout.propTypes = {
  history: PropTypes.object,
};

export default withRouter(Logout);